import type { ReactNode } from 'react';
import { DialogBase, type DialogBaseProps } from './DialogBase';

export interface SheetProps extends Omit<DialogBaseProps, 'mode' | 'children'> {
  children: ReactNode;
}

export function Sheet(props: SheetProps) {
  return <DialogBase {...props} mode="sheet" />;
}
